import React from 'react'
import './index.css';
import util from "../../../util/tools";
import P from "prop-types";
const closeImg = require('../../../images/x.png')

class ActivityPopup extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };

    constructor(props) {
        console.log(props)
        super(props);
        this.state = {
            popupId: props.popupId,
            activityUrl: props.activityUrl
        }
    }
    componentDidMount () {
        
    }
    
    eventCallback(e){
        // console.log(44456,e);
        e.preventDefault();
    }
    jumpFn() {
        util.ajax({
            url: '/zh/activity/activityclick',
            data: {
                activity_id: this.props.activityId
            },
            callback: (res) => {
                if (res.result.status.code == 0) {
                    // console.log(this.state.activityUrl)
                    window.location.href = this.state.activityUrl
                }
            }
        })
    }
    closePopup = () => {
        console.log(this.props)
        this.props.closePopup()
    }
    render () {
        return (
            <div className='activity-popup'>
                <div className='popup-box'>
                    <img src={ require(`../../../images/popup${this.state.popupId}-min.png`) } />
                    <span className='recharge-btn' onClick={this.jumpFn.bind(this)}></span>
                </div>
                <div className='close-box'>
                    <img src={ closeImg } onClick={this.closePopup} />
                </div>
            </div>
        )
    }
}

export default ActivityPopup